import * as React from "react";

import {widgetStyles} from "@client/forms/widgets";

interface Props {
    error: string | null;
    children?: React.ReactNode;
}

export const FieldError = ({children, error}: Props) => (
    <>
        {children}
        {error != null && <div className={widgetStyles.FieldError}>{error}</div>}
    </>
);
